/**
 * @module api-scm:discardOrder
 */
import service from '@/service'

// 查询
export function getList(data) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/discardOrder/getList',
    method: 'post',
    data
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 导出
export function exportData(data) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/discardOrder/export',
    method: 'post',
    data
  })
}

// 新增
export function create(data) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/discardOrder/save',
    method: 'post',
    data
  })
}

// 详情
export function info(id) {
  return service['api-scm']({
    url: `/scm/warehouse/defectiveManage/discardOrder/info`,
    method: 'get',
    params: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 编辑
export function update(data) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/discardOrder/update',
    method: 'post',
    data
  })
}

// 删除
export function remove(data) {
  return service['api-scm']({
    url: `/scm/warehouse/defectiveManage/discardOrder/delete`,
    method: 'post',
    data
  })
}

// 提交
export function submit(id) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/discardOrder/submit',
    method: 'post',
    data: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 选择明细
export function pickDetail(data) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/discardOrder/info/pickDetail',
    method: 'post',
    data
  })
}

// 审核
export function audit(data) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/discardOrder/audit',
    method: 'post',
    data
  })
}

/**
 * @param {string} id
 * @description 撤销
 */
export function withdraw(id) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/discardOrder/withdraw',
    method: 'post',
    data: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 待办审核驳回
export function reject(data) {
  return service['api-scm']({
    url: '/public/activiti/discardOrder/reject',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 *
 * @param {{string}} id
 * @returns
 * @description  待办详情 (无需权限)
 */
export function todoInfo(id) {
  return service['api-scm']({
    url: '/public/activiti/discardOrder/info',
    method: 'get',
    params: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {string} inventoryProductIds
 * @description 刷新库存
 */
export function refreshInventory(data) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/discardOrder/info/flushDefectiveNumber',
    method: 'post',
    data
  })
}

/**
 * 手动对接金蝶
 */
export function manualDock2Kd(data) {
  return service['api-scm']({
    url: '/scm/warehouse/defectiveManage/discardOrder/manualDock2Kd',
    method: 'post',
    data
  })
}
